import Chocolat from 'chocolat';

(() => {
    const images = Array.from(
        document.querySelectorAll('[data-lightbox-image]'),
    );

    if (images.length) {
        const slides = images.map(image => {
            const { src, width, height } = image.dataset;

            return {
                src,
                width,
                height,
            };
        });

        const { api } = Chocolat(slides, {
            // options here
        });

        images.forEach((image, index) => {
            image.addEventListener('click', () => {
                api.open(index);
            });
        });
    }
})();
